// removed by extract-text-webpack-plugin
module.exports = {"Countdown":"Countdown__22Sbg","inner":"inner__3qzTL","text":"text__2BYoe"};